/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ItemFromJSON, ItemToJSON, } from './Item.js';
/**
 * Check if a given object implements the ListNewJobReasonsResult interface.
 */
export function instanceOfListNewJobReasonsResult(value) {
    if (!('newJobReasons' in value) || value['newJobReasons'] === undefined)
        return false;
    return true;
}
export function ListNewJobReasonsResultFromJSON(json) {
    return ListNewJobReasonsResultFromJSONTyped(json, false);
}
export function ListNewJobReasonsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'newJobReasons': (json['newJobReasons'].map(ItemFromJSON)),
    };
}
export function ListNewJobReasonsResultToJSON(json) {
    return ListNewJobReasonsResultToJSONTyped(json, false);
}
export function ListNewJobReasonsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'newJobReasons': (value['newJobReasons'].map(ItemToJSON)),
    };
}
